







import { defineComponent, computed } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import FigureSlider from '~/components/feature/PDP/FigureSlider.vue'
import { Figure } from '~/types/product/productTypes'
import { PLACEHOLDER_IMAGE_FILENAME, applicationsWithOwnChiclet } from '~/common/utils/product/constants'

export default defineComponent({
  components: {
    FigureSlider,
  },
  props: {
    images: {
      type: Array as () => Figure[],
      required: false,
      default: () => [],
    },
    activeChiclet: {
      type: String,
      required: false,
      default: null,
    },
    useRelatedAndConjugatesUI: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['on-filtered-images'],
  setup(props, { emit }) {
    const noImgPlaceholder = [{ filename: PLACEHOLDER_IMAGE_FILENAME }]

    const mappedImages = computed(() => {
      const arrayOfMappedImages = props.images
      if (!props.activeChiclet) {
        return arrayOfMappedImages
      } else {
        const filteredArrayOfMappedImages = arrayOfMappedImages.filter((f: Figure) =>
          applicationsWithOwnChiclet.includes(props.activeChiclet)
            ? f.codeForDisplay === props.activeChiclet
            : f.codeForDisplay === 'other'
        )
        emit('on-filtered-images', filteredArrayOfMappedImages)
        return filteredArrayOfMappedImages
      }
    })
    return { mappedImages, isEmpty, noImgPlaceholder }
  },
})
